import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Welcome from './pages/Welcome';
import AboutUs from './pages/AboutUs';
import BookPage from './pages/BookPage';
import Showteam from './pages/Showteam';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/over-ons" element={<AboutUs />} />
        <Route path="/kay-2" element={<AboutUs />} />
        <Route path="/showteam" element={<Showteam />} />
        <Route path="/leesvoer" element={<BookPage />} />
      </Routes>
    </Router>
  );
};

export default App;
